/** true, коли зараз раніше моменту «Почати з». Порожній початок обмеження не дає. */
export const isBeforeTaskStart = (dateStart?: number | null, now = Date.now()): boolean => {
    const start = Number(dateStart || 0);
    return start > 0 && now < start;
};
